import { PostCodeArgs } from 'types/api/arguments/post-code-args'
import { PostCodeResponse } from 'types/api/response/post-code-response'

import { api } from './api'

export const getPostalCodeConfiguration = ({ code, countryId }: PostCodeArgs) =>
  api.get<PostCodeResponse>(`postal_codes/${code}`, {
    params: {
      country_id: countryId,
    },
  })
